<span
  class="admin-badge"
  [ngClass]="roleClass"
  [attr.aria-label]="ariaLabel"
  data-testid="admin-badge"
  >{{ label }}</span
>
